module.exports = __webpack_public_path__ + "img/icon-list-grey.421bcac4.svg";